<template>
    <div class="body">
      <div class="header">
        <el-form :model="AutomaticWebQuotationSelectDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>
          
          <el-form-item label="产品种类">
              <el-input
                v-model="AutomaticWebQuotationSelectDTO.category"
                placeholder="产品种类"
              ></el-input>
            </el-form-item>
   
            <el-button class="btn-style btn-search"  type="primary" @click="serchInfo">
              搜索
            </el-button>
            <br>
          <el-form-item>
            <el-button  class="btn-style btn-cancel" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button  class="btn-style btn-delete"  type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
        <password ></password>
        <el-dialog
                text-align="center"
                :close-on-click-modal="false"
                title="编辑报价"
                class="order-dialog"
                center
                @close="closeDialog"
                :visible.sync="drawer"
            >
                <el-form
                    ref="accountForm"
                    :rules="rules"
                    :model="accountForm"
                    class="demo-accountForm form-style"
                >
                    <div class="accountForm-header">
                   
                              <el-form-item label="产品种类" prop="category">
                            <el-select clearable size="small" v-model="accountForm.category" allow-create
                            :disabled="detailDisable"
                                       filterable
                                        @blur.native.capture="categorySelect">
                                <el-option
                                    v-for="item in category"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                        </el-form-item>
                        
                    
                    </div>
                    <el-button  type="warning" class="btn-add" size="small" @click="addFrom" >添加范围</el-button>
                    <el-button
                        class="form-submit"
                        size="small"
                        type="success"
                        @click="submitForm('accountForm')"
                        v-if="!detailDisable"
                    >
                        立即创建
                    </el-button>
                    <el-button
                        class="form-submit"
                        size="small"
                        type="success"
                        @click="editAccount('accountForm')"
                        v-if="detailDisable"
                    >
                        确认修改
                    </el-button>
                <el-row v-for="(form, index) in accountForm.ranges" :key="index">
                <el-form
                    label-position="right"
                    :model="form"
                    :ref="accountForm.ranges"
                    :inline="true"
                >
                <el-row >
                     <el-col :span="5">
                       <el-form-item label="尺寸区间(公分):" size="small" prop="nickname" :parser="transformNum">
                      <el-input v-model.trim="form.lessEqual"></el-input>
                    </el-form-item>

             
                </el-col>
                <el-col :span="5">
                    <el-form-item label="计价单位:" size="small" prop="nickname">
                      <el-select clearable size="small" v-model.trim="form.pricingUnit" allow-create
                                       filterable
                                      >
                                <el-option
                                    v-for="item in pricingUnit"
                                    clearable
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                />
                            </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="中文价格:" size="small" prop="code">
                    <el-input v-model.trim="form.chinesePrice"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="5">
                    <el-form-item label="英文价格:" size="small" prop="code">
                    <el-input v-model.trim="form.englishPrice"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
        <el-button
        type="danger"
        size="small"
        icon="el-icon-delete"
        circle
        @click="_ly_delFrom(index)"></el-button>
      </el-col> 
      </el-row>
  </el-form>
</el-row>
                </el-form>
            </el-dialog>
        <div style="display: flex">
          
          <!-- <el-button
            
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <div class="pagination">
                    <el-pagination
                        :current-page="currentPage"
                        :page-sizes="[10, 30, 50, 100]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>

      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
    
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="category"
            align="center"
            label="产品品类"
            width="400"
          ></el-table-column>
      <el-table-column prop="ranges" label="范围明细">
        <template slot-scope="scope">
          <el-table :data="scope.row.ranges">
          <el-table-column
            prop="lessEqual"
            align="center"
            label="尺寸区间(公分)"
          ></el-table-column>
          <el-table-column
            prop="pricingUnit"
            align="center"
            label="计价单位"
          ></el-table-column>
          <el-table-column
            prop="chinesePrice"
            align="center"
            label="中文单价"
          ></el-table-column>
          <el-table-column
            prop="englishPrice"
            align="center"
            label="英文单价"
          ></el-table-column>
          </el-table>
        </template>
      </el-table-column>
       
               <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success"  @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>
  

    </div>
  </template>
  
  <script>
   import password from '@/components/password.vue';
  import {addAutomaticQuotation,selectWebAutomaticQuotation,bathDelete,updateAutomaticQuotation,getAllCategory} from '@/api/set/quotation.js'
  export default {
    components: {
      password
  },
    data() {
      return {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        cellClassName: {
          shortcuts: [
          {
              text: '最近一天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三天',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]
  
        },
        date: '',
        conTract: [],
        AutomaticWebQuotationSelectDTO:{
          access:'',
            startTime: '',
            endTime: '',
            category: '',
        },
        category:[],
        pricingUnit:["个","平米","米(字算法)","公分(字算法)"],
        drawer: false,
        dialogVisible:false,
        accountForm: {
                id: '',
                access: '',
                category:'',
                ranges:[]
            },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        },
        detailDisable:false,
        rules: {
          category:[
          { required: true, message: '请选择产品种类', trigger: 'blur' }]
            },
       
      }
    },

  
    mounted() {
      this.AutomaticWebQuotationSelectDTO.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
      this.getAllCategory()
    },
    methods: {
     transformNum (value) {
  let v = null
  switch (typeof value) {
    case 'string':
      v = isNaN(+value) ? 0 : value.replace(/\./g, '')
      break
    case 'number':
      v = isNaN(value) ? 0 : String(value).replace(/\./g, '')
      break
    default:
      v = 0
  }
  console.log(v)
  this.form.lessEqual=v
},

      getAllCategory() {
        getAllCategory(localStorage.getItem("access")).then((res) => {
                this.category = res.data.data
                //  this.total = Number(res.data.data.total)
            })
        },
        addFrom () {
    //   if (this.accountForm.ranges.length >= 5) {
    //     this.$message.warning('最多只能添加5行')
    //     // 如果需要更多行，可以调整[dialog-content]的高度，或者将界面调整为允许滚动
    //     return
    //   }
      this.accountForm.ranges.push({
        greater:'',
        lessEqual:'',
        chinesePrice:'',
        englishPrice:''
      })
    },
          //删除一行
          _ly_delFrom (index) {
      console.log('index: ' + index)
      this.accountForm.ranges.splice(index, 1)
      console.log(this.accountForm.ranges)
    },
    closeDialog(){
            this.accountForm = { 
                id: '',
                access: '',
                category:'',
                pricingUnit:'',
                ranges:[]
            }
            this.goodsTableData = []
        },
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      tohandleEdit(){
   
        this.detailDisable=false
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
        this.addFrom() 
      },

      handleEdit(row) {
        this.drawer = true
        this.detailDisable=true
        this.accountForm= row
      },
      getTableData() {
        selectWebAutomaticQuotation(this.AutomaticWebQuotationSelectDTO).then((res) => {
            console.log(res);
          this.conTract = res.data.data
        })
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addAutomaticQuotation(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
              })
              this.getTableData()
             } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
        console.log(this.accountForm)
      },
   //修改
   editAccount() {
    updateAutomaticQuotation(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.drawer = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            bathDelete(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     
  
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
  
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.AutomaticWebQuotationSelectDTO.startTime = e[0]
          this.AutomaticWebQuotationSelectDTO.endTime = e[1]
        } else if (!e) {
          this.AutomaticWebQuotationSelectDTO.startTime = ''
          this.AutomaticWebQuotationSelectDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
      categorySelect(e) {
                if(e.target.value) { 
                    this.accountForm.category = e.target.value
            }
        },
   
   
    }
  }
  </script>
  
  <style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
}

.body {
    overflow: auto;
}

.pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
}

.el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
.goodsTableData{
    margin: 20px 0 ;
}
.btn-style{
    min-width: 72px;
    border-radius: 8px;
}
.btn-search{
    background: var(--theme-color);
}
.btn-buy{
    background: #FF8429;
}
.btn-print{
    background: #4093FF;
}
.btn-delete{
    background: #FF4D4D;
}
.btn-view{
    background: var(--theme-color);
}
.product-form .el-form-item{
    margin-bottom: 0;
}
.table-content{
    margin: 20px;
}
.check-all{
    color: #333;
    font-size: 16px;
    margin-right: 20px;
    cursor: pointer;
}
.el-pagination{
    margin: 0;
}

.el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
    border-radius: 8px;
}

.table-label{
    color: var(--secondColor);
}
.table-value{
    color: var(--color);
}
.table-info{
    width: 80%;
    justify-content: space-between;
}
.table-info > p{
    display: inline-block;
    width: 150px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.table-item{
    background: #F7F7F7;
    margin: 8px 0;
    border-radius: 12px;
    padding: 12px;
}
.table-image{
    width: 100px;
    height: 50px;
    margin-right: 20px;
}
::v-deep.table-image .image-slot{
    height: 50px;
    display: flex;
    align-items: center;
}
::v-deep.table-image .image-slot i{
    font-size: 50px;
}
.pay{
    color:var(--theme-color);
}
.no-pay{
    color:#FF4D4D;
}
.btn-group{
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.btn-group .el-button{
    border-radius: 20px;
    width: 76px;
}
.btn-collection{
    background: #F9DDDD;
}
.btn-view-detail{
    background: #D3F2E4;
    color: var(--theme-color);
}

::v-deep.order-dialog .el-dialog{
    border-radius: 24px;
}
.operator label{
    letter-spacing: 5px;
}
::v-deep.dialog-upload{
    display: flex;
}
::v-deep.dialog-upload .el-form-item__label{
    flex-shrink: 0;
}
::v-deep.dialog-upload .el-form-item__content{
    justify-content: right;
}
::v-deep.dialog-upload .avatar-uploader{
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #D8E0DD;
}
::v-deep.dialog-upload .el-upload--text{
    width: 100%;
    height: 100%;
}
::v-deep.dialog-upload img{
    max-width: 100px;
}
.accountForm-header{
    background: #F7F7F7;
    border-radius: 16px;
    margin-bottom: 20px;
    padding: 20px;
}
.btn-add{
    background: #FF8429;
    border-radius: 8px;
}
.form-submit{
    background: var(--theme-color);
    border-radius: 8px;
}
::v-deep.el-table thead th{
    background: #EAF4F0;
    color: var(--secondColor);
}
.table-no-pay{
    background: #ffeded;
}

::v-deep.el-icon-remove-outline{
    font-size: 32px;
    color: #a3d8f9cc;
}


  .btn-download , .btn-confirm{
      background: #4093FF;
  }
  .btn-redownload , .btn-cancel{
      background: #FF8429;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  
  </style>
  